"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstOptionFromGroup = exports.getFirstOption = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getFirstOption = options => {
  // pick the first option from the options
  if (options.length > 0) {
    return options[0];
  }
  return null;
};
exports.getFirstOption = getFirstOption;
const getFirstOptionFromGroup = groupTitleOptions => {
  if (groupTitleOptions.length > 0) {
    const firstGroup = groupTitleOptions[0];
    if (firstGroup.options && firstGroup.options.length > 0) {
      return firstGroup.options[0];
    }
  }
  return null;
};
exports.getFirstOptionFromGroup = getFirstOptionFromGroup;